import { withStyles } from "@material-ui/core/styles";
import styles from "./FranchiseStyles";
import { Grid, Typography
} from "@mui/material";
import axios from "axios";
import FranchiseTable from './FranchiseTable/FranchiseTable'
import FranchiseForm from './FranchiseForm/FranchiseForm'
import { useEffect, useState } from "react";
import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";

const Franchise = ({ classes }) => {
  const [franchiseList, setFranchiseList] = useState([])
  const [handleModal, setHandleModal] = useState("")
  const [reset, setReset] = useState(false)
  const [checkApp, setCheckApp] = useState(false)
  const [checkStatus, setCheckStatus] = useState(false)
  const [mainList, setMainList] = useState([])
  const [record, setRecord] = useState({
    franchisee_code:"",
    franchiseetype:"",
    feeamount:"",
    name:"",
    email:"",
    mobile:"",
    district:"",
    state:"",
    pincode:"",
    expert_advice_fee:"",
    expert_advice_days:"",
    wealth_vault_fee:"",
    wealth_vault_days:"",
    status: false,
    app_download_status:false
  })

  useEffect(()=>{
    (async() => {
      try{
        const franchise_list = await axios.get(`${backendHosts.ADMIN}${apiUrl.franchiseeList}`)
        console.log("fran",franchise_list.data?.data?.data?.data)
     
        setFranchiseList(franchise_list.data?.data?.data?.data)
      setMainList(franchise_list.data)
      }catch(err){
        console.log("An Error", err)
      }
    })()
  },[reset])

  const handleSearch = (value)=>{
    if(value !==""){
      const filteredList = franchiseList.filter((ele)=>{
        if(ele.franchisee_code.includes(value.toUpperCase())){
          return ele
        }
      })
      setFranchiseList(filteredList)
    }else{
      setFranchiseList(mainList)
    }
  }
  
  const handleCheckStatus = () => {
    if(checkStatus === false){
      const filteredList = franchiseList.filter((ele)=>{
        if(ele.status === true){
          return ele
        }
      })
      setFranchiseList(filteredList)
    }else{
      setFranchiseList(mainList)
    }
    setCheckStatus(!checkStatus)
  }

  const handleCheckApp = () => {
    if(checkApp === false){
      const filteredList = franchiseList.filter((ele)=>{
        if(ele.app_download_status === true){
          return ele
        }
      })
      setFranchiseList(filteredList)
    }else{
      setFranchiseList(mainList)
    }
    setCheckApp(!checkApp)
  }
 
  const handleReset = () => {
    setReset(!reset)
  }

  return (
    <Grid className={classes.mainGrid}>
      <Grid className={classes.textGrid}>
        <Typography className={classes.campaignText}>Franchise Table</Typography>
      </Grid>
      <FranchiseTable franchiseList={franchiseList} setHandleModal={setHandleModal} setRecord={setRecord} handleSearch={handleSearch} handleReset={handleReset} checkApp={checkApp} handleCheckApp={handleCheckApp} checkStatus={checkStatus} handleCheckStatus={handleCheckStatus}/>
      <FranchiseForm handleModal={handleModal} setHandleModal={setHandleModal} record={record} setRecord={setRecord} franchiseList={franchiseList} setFranchiseList={setFranchiseList} handleReset={handleReset} mainList={mainList} setMainList={setMainList}/>
    </Grid>
  );
};
export default withStyles(styles)(Franchise);
